import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet'
import { Provider, useDispatch } from 'react-redux';
import logo1 from '../../../assets/cropped-logo_white.png'
import { getCurrentSubTab, getCurrentTab } from '../../../redux/actions/adminSideMenuAction';
import { setMemActEventId, setMemActEventName } from '../../../redux/actions/memActActions';
import { database } from '../../../utils/firebase';
import Paginate from '../Pagination';
import './MemAct.scss'
import MemActPopUp from './MemActPopUp';
import SavedMembers from './SavedMembers';





const MemAct = () => {
    const [eventData, setEventData] = useState([])
    const [offset, setOffset] = useState(10)
    const [noOfPages, setNoOfPages] = useState('')
    const [pageArray, setPageArray] = useState([])
    const [noOfData, setNoOfData] = useState('')
    const [loadedData, setLoadedData] = useState([])
    const [activePage, setActivePage] = useState(1)
    const [pageState, setPageState] = useState('')
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getCurrentSubTab('seratt'))
    }, [dispatch])

    const numArr = (num) => {
        const arr = []
        for (let i = 1; i <= num ; i++) {
          arr.push(i)
        }
        return arr
      }

    useEffect(() => {
        setNoOfPages(Math.ceil((eventData.length)/10))
        setNoOfData(eventData.length)
        setOffset(10 * activePage)
        setLoadedData(eventData.slice((offset - 10), offset))
        setPageArray(numArr(noOfPages))
    }, [activePage, eventData, noOfData, noOfPages, offset])

    useEffect(() => {
        if(pageArray.length > 0) {
            document.querySelectorAll('.page-box').forEach(el => {
                el.classList.remove('active')
            })
            if(document.querySelector(`.page${activePage}`) === null) {   
                setActivePage(pageState - 1)
            } else {   
                return document.querySelector(`.page${activePage}`).classList.add('active')
            }   
        }
        
    }, [activePage, eventData, pageArray, pageArray.length, pageState])

    useEffect(() => {
        const eventRef = database.ref('Events')
        eventRef.on('value', (el) => {
            let eData = []
            for (let id in el.val()) {
                eData.unshift({id, ...el.val()[id]})
            }
            setEventData(eData)
        })
    }, [])
    
    const handleViewEvent = (id, name) => {
        dispatch(setMemActEventId(id))
        dispatch(setMemActEventName(name))
        let elmnt = document.querySelector(".content-view");
        let y = elmnt.scrollHeight;
        document.querySelector('.admin-background').classList.remove('hide')
        document.querySelector('.admin-background').style.height = `${y + 110}px`
        document.querySelector(`.pop${id}`).classList.remove('hide')
        document.querySelector(`.pop${id}`).scrollIntoView();
        setTimeout(() => {
            let elmnt = document.querySelector(".content-view");
            let y = elmnt.scrollHeight;
            document.querySelector('.admin-background').style.height = `${y + 110}px`
        }, 100);
    }

    return (
        // Dont use span tag here if at all you can use span1 or span2 never span
        <div className='lang-view mem-act-view events-view'>
            <Helmet htmlAttributes>
                <meta charSet="utf-8" />
                <html lang="en" />
                <title>Admin-Members Activities | LVZConnect</title>
                <meta name="description" content="LVZConnect Admin Languages Page" />
            </Helmet>
            <div className="top">
                <div>
                    <img src={logo1} alt="" />
                    <h3>MEMBERS ACTIVITIES</h3>
                </div>
                
                {/* <button >Add Language +</button> */}
            </div>
            <div className="table-container">
                <div className="table title">
                    <div className="num dd">#</div>
                    <div className="event dd">Event</div>
                    <div className="e-date dd">Date</div>
                    <div className="l-actions dd">Actions</div>
                </div>

               
                {loadedData.map((el, i) => {
                    return (
                        <div className="table details" key={el.id}>
                            {/* <Alert message={alertMessage} eventId={el.id} action={setLanguageAlert} /> */}
                            <MemActPopUp eventID={el.id} eventName={el.eventName}/>
                            <div className="num dd">{i + 1}</div>
                            <div className="event dd">{el.eventName}</div>
                            <div className="e-date dd">
                                <div>{el.eventDate}</div>
                                <div>{el.eventTime}</div>
                            </div>
                            <div className="l-actions dd">
                                <button className='view' title='View Members Activity' onClick={() => handleViewEvent(el.id, el.eventName)}>View Report</button>
                                {/* <button className='edit' title='Edit' onClick={()=> handleEventEdit(el.id)}><i class="fas fa-edit"></i></button>
                                <button className='clone' title='Clone' onClick={() => handleEventClone(el.id)}><i class="far fa-copy"></i></button> */}
                            </div>
                        </div>

                    )
                })} 
                
               
            </div>

            

            {loadedData.length > 0? 
                <Paginate activePage={activePage} setActivePage={setActivePage} pageArray={pageArray} noOfPages={noOfPages} /> : 
                ''
            }  
        </div>
    )
}

export default MemAct